import type { PipeTransform } from '@angular/core';
import { Pipe } from '@angular/core';
import type { PalantirLabelColors } from './labels.type';
import { palantirLabelColorsMap } from './labels.type';

@Pipe({
  name: 'labels',
  standalone: true,
})
export class LabelsPipe implements PipeTransform {
  public transform(value: PalantirLabelColors): {
    color: string;
    contrast: string;
  } {
    return palantirLabelColorsMap[value];
  }
}
